import {memo, useMemo} from "react";
import {Table} from "antd";
import {numberFormat} from "~/utils";
import {StatusLabel} from "../../../../components";

function ContractReportTable({items, type, types, total}) {

	const columns = [
		{ title: 'Loại hợp đồng', dataIndex: 'contractType', key: "contractType", width: '210px', render: (_, item) => (
			<><StatusLabel small type={item?.badge}>{item?.name}</StatusLabel></>
		)},
		{ title: 'Ký mới', dataIndex: 'new', key: "new", width: '110px', render: (_, item) => (
			<>{numberFormat(item?.types?.new?.[type])}</>
		)},
		{ title: 'Up source', dataIndex: 'upsource', key: "upsource", width: '110px', render: (_, item) => (
			<>{numberFormat(item?.types?.upsource?.[type])}</>
		)},
		{ title: 'Up bên ngoài', dataIndex: 'upgradenew', key: "upgradenew", width: '110px', render: (_, item) => (
				<>{numberFormat(item?.types?.upgradenew?.[type])}</>
			)},
		{ title: 'Nâng cấp', dataIndex: 'Update', key: "Update", width: '110px', render: (_, item) => (
				<>{numberFormat(item?.types?.upgrade?.[type])}</>
			)},
		{ title: 'Gia hạn', dataIndex: 'Update', key: "Update", width: '110px', render: (_, item) => (
				<>{numberFormat(item?.types?.extension?.[type])}</>
			)},
		{ title: 'Tổng', dataIndex: 'total', key: "total", width: '110px', fixed: 'right', render: (_, item) => (
			<>{numberFormat(item?.total?.[type])}</>
		)},
	];

	let dataSource = useMemo(() => {
		return Object.values(items)
	}, [items]);

	console.log(type)

	return (
		<div className="table-box">
			<Table
				columns={columns}
				rowKey="id"
				dataSource={dataSource}
				scroll={{ x: 'max-content' }}
				pagination={false}
				summary={() => (
					<Table.Summary fixed>
						<Table.Summary.Row>
							<Table.Summary.Cell index={0}><b>Tổng</b></Table.Summary.Cell>
							<Table.Summary.Cell index={1} colSpan={1}>{numberFormat(types?.new?.[type])}</Table.Summary.Cell>
							<Table.Summary.Cell index={2} colSpan={1}>{numberFormat(types?.upsource?.[type])}</Table.Summary.Cell>
							<Table.Summary.Cell index={3} colSpan={1}>{numberFormat(types?.upgradenew?.[type])}</Table.Summary.Cell>
							<Table.Summary.Cell index={4} colSpan={1}>{numberFormat(types?.upgrade?.[type])}</Table.Summary.Cell>
							<Table.Summary.Cell index={4} colSpan={1}>{numberFormat(types?.extension?.[type])}</Table.Summary.Cell>
							<Table.Summary.Cell index={5}><b>{numberFormat(total?.[type])}</b></Table.Summary.Cell>
						</Table.Summary.Row>
					</Table.Summary>
				)}
			/>
		</div>
	)
}

export default memo(ContractReportTable);